// ============================================
// Wall Construction Definitions
// Swedish building standards (simplified)
// ============================================

import { WallConstruction } from '@/types';

export const WALL_CONSTRUCTIONS: WallConstruction[] = [
  // ===== Ytterväggar (Exterior walls) =====
  {
    id: 'ext-traguiden',
    name: 'TräGuiden bärande yttervägg',
    type: 'exterior',
    thickness: 412,
    description: '45×195 reglar, 285mm total isolering (195+45+45), OSB+gips invändigt',
    layers: [
      'Lockläkt 22mm',
      'Ytterpanel 22mm',
      'Spikläkt 34×70mm',
      'Luftningsläkt 23mm',
      'Utvändig isolering 45mm',
      'Vindskyddsduk',
      'Reglar 45×195mm (bärande)',
      'Isolering 195mm',
      'Ångspärr/ångbroms',
      'Horisontella reglar 45×45mm (installationsskikt)',
      'Isolering 45mm',
      'OSB 11mm',
      'Gipsplast 12,5mm',
    ],
  },
  {
    id: 'ext-standard',
    name: 'Standard yttervägg',
    type: 'exterior',
    thickness: 300, // mm
    description: 'Trästomme 45×145, isolering 145+100mm, gips inv, panel utv',
    layers: [
      'Ytterpanel (stående/liggande)',
      'Luftspalt 25mm',
      'Vindpapp',
      'Reglar 45×145mm',
      'Isolering 145mm',
      'Isolering 100mm (tillägg)',
      'Gipsplast invändigt',
    ],
  },
  {
    id: 'ext-thick',
    name: 'Tjock yttervägg',
    type: 'exterior',
    thickness: 350,
    description: 'Trästomme 45×195, isolering 195+100mm, gips inv, panel utv',
    layers: [
      'Ytterpanel (stående/liggande)',
      'Luftspalt 25mm',
      'Vindpapp',
      'Reglar 45×195mm',
      'Isolering 195mm',
      'Isolering 100mm (tillägg)',
      'Gipsplast invändigt',
    ],
  },
  {
    id: 'ext-wood-simple',
    name: 'Enkel trätomme',
    type: 'exterior',
    thickness: 200,
    description: 'Reglar 45×145, isolering 145mm, panel utv, gips inv',
    layers: [
      'Ytterpanel',
      'Reglar 45×145mm',
      'Isolering 145mm',
      'Gipsplast invändigt',
    ],
  },

  // ===== Innerväggar (Interior walls) =====
  {
    id: 'int-standard',
    name: 'Standard innervägg',
    type: 'interior',
    thickness: 142,
    description: 'Reglar 45×95, OSB+gips på båda sidor',
    layers: [
      'Gipsplast 12,5mm',
      'OSB 11mm',
      'Reglar 45×95mm',
      'Isolering 95mm',
      'OSB 11mm',
      'Gipsplast 12,5mm',
    ],
  },
  {
    id: 'int-sound',
    name: 'Ljudisolerad',
    type: 'interior',
    thickness: 200,
    description: 'Dubbla reglar, isolering, gips',
    layers: [
      'Gipsplast',
      'Reglar 45×95mm',
      'Isolering 95mm',
      'Luftspalt',
      'Reglar 45×70mm',
      'Isolering 70mm',
      'Gipsplast',
    ],
  },
  {
    id: 'int-simple',
    name: 'Enkel avskiljande',
    type: 'interior',
    thickness: 100,
    description: 'Reglar 45×70, gips på båda sidor',
    layers: [
      'Gipsplast',
      'Reglar 45×70mm',
      'Gipsplast',
    ],
  },
];

export function getWallConstruction(id: string): WallConstruction | undefined {
  return WALL_CONSTRUCTIONS.find(c => c.id === id);
}

export function getExteriorWalls(): WallConstruction[] {
  return WALL_CONSTRUCTIONS.filter(c => c.type === 'exterior');
}

export function getInteriorWalls(): WallConstruction[] {
  return WALL_CONSTRUCTIONS.filter(c => c.type === 'interior');
}
